const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export default function ReportDocument({patient,doctor,reportText}) {
    return (
        <div id="reportDocument" style={{width: "210mm",minHeight: "297mm",background: "#fff",padding: "20mm",color: "#000"}}>
            <h2 style={{textAlign:"center"}}>
                {patient.center_name}
            </h2>
            <hr/>
            <table style={{width:"100%"}}>
                <tbody>
                    <tr>
                        <td><b>Patient Name</b></td>
                        <td>{patient.patient_name}</td>
                        <td><b>Patient ID</b></td>
                        <td>{patient.patient_id}</td>
                    </tr>
                    <tr>
                        <td><b>Age / Sex</b></td>
                        <td>{patient.patient_age} / {patient.patient_gender}</td>
                        <td><b>Study Date</b></td>
                        <td>{patient.study_date}</td>
                    </tr>
                    <tr>
                        <td><b>Modality</b></td>
                        <td>{patient.modality}</td>
                        <td><b>Ref Doctor</b></td>
                        <td>{patient.referring_physician}</td>
                    </tr>
                </tbody>
            </table>
            <hr/>
            <div style={{minHeight: "500px",lineHeight: "1.6"}}
                dangerouslySetInnerHTML={{ __html: reportText }}
                />
            <div style={{ marginTop:80,textAlign:"left"}}>
                {patient.signature && (
                    <img src={`${API_BASE_URL}/${patient.signature}`} width={140} alt="signature" crossOrigin="anonymous"/>
                )}
                <br/>
                <strong>{patient.doctor_name}</strong>
                <br/>
                {patient.qualification || 'MBBS & DNB (Radiologist)'}
                <br/>
                Reg. No : {patient.registration_number || '5845145'}
            </div>
        </div>
    );
}